
function mmInitStepVideos() {
  let sliders = document.querySelectorAll(".splide-steps-videos");
  sliders.forEach((slider) => {
    var splide = new Splide(slider, {
      type: "slide",
      arrows: false,
      pagination: false,
      perPage: 4,
      gap: 20,
      breakpoints: {
        768: {
          perPage: 1,
          padding: {
            right: '2em'
          }
        }
      }
    }).mount();


    splide.on( 'active', function () {
      var mmVideos = slider.querySelectorAll("video");
      console.log('videos all', mmVideos);
      mmVideos.forEach(function (mmVideo) {
        mmVideo.pause();
        mmVideo.currentTime = 0;
      });

      var mmSlide = slider.querySelector(".splide__slide.is-active");
      var mmVideo = mmSlide.querySelector("video");
      mmVideo.play();
    });

    startFirstVideo(slider);
  })
};

function startFirstVideo(slider) {
  var mmVideos = slider.querySelectorAll("video");
  mmVideos.forEach(function (mmVideo) {
    mmVideo.pause();
    mmVideo.currentTime = 0;
  });

  mmVideos[0].play();
}

const VideoController = function (isHovering, videoElement) {
  var splide = document.querySelector(".splide-steps-videos");
  var mmVideos = splide.querySelectorAll("video");
  if (isHovering == true) {
    mmVideos.forEach(function (mmVideo) {
      mmVideo.pause();
      mmVideo.currentTime = 0;
    });
    videoElement.querySelector('video').play();
  }
};





document.addEventListener("DOMContentLoaded", () => {
	mmInitStepVideos();
});
